import client from '../client';
import endpoints from '../endpoints';

/**
 * FAQ / 문의 — 서비스 + 관리자 API
 * API_DOCS: 12. 문의 & FAQ / 28. 관리자 - 문의/FAQ
 */

/* ── 서비스 (유저용) ── */

/** GET /api/faq/categories — 활성 FAQ distinct 카테고리 + 전체('all') */
export const getFaqCategories = async () => {
  const res = await client.get(endpoints.faq.categories);
  return res.data;
};

export const getFaqs = async (params = {}) => {
  const res = await client.get(endpoints.faq.list, { params });
  return res.data;
};

export const getFaqById = async (id) => {
  const res = await client.get(endpoints.faq.detail(id));
  return res.data;
};

export const createInquiry = async (data) => {
  const res = await client.post(endpoints.inquiries.create, data);
  return res.data;
};

export const getInquiries = async (params = {}) => {
  const res = await client.get(endpoints.inquiries.list, { params });
  return res.data;
};

export const getInquiryById = async (id) => {
  const res = await client.get(endpoints.inquiries.detail(id));
  return res.data;
};

/* ── 관리자 ── */

export const getAdminFaqs = async (params = {}) => {
  const res = await client.get(endpoints.admin.faq.list, { params });
  return res.data;
};

export const createFaq = async (data) => {
  const res = await client.post(endpoints.admin.faq.list, data);
  return res.data;
};

export const updateFaq = async (id, data) => {
  const res = await client.put(endpoints.admin.faq.detail(id), data);
  return res.data;
};

export const deleteFaq = async (id) => {
  const res = await client.delete(endpoints.admin.faq.detail(id));
  return res.data;
};

export const getAdminInquiries = async (params = {}) => {
  const res = await client.get(endpoints.admin.inquiries.list, { params });
  return res.data;
};

export const getAdminInquiryById = async (id) => {
  const res = await client.get(endpoints.admin.inquiries.detail(id));
  return res.data;
};

export const answerInquiry = async (id, data) => {
  const res = await client.put(endpoints.admin.inquiries.detail(id), data);
  return res.data;
};
